import Client from '../client';
import {flattenObject} from '../helpers';
import {
  FetchBasalamProductsRequestBuilder,
  FetchRegistrationTimes,
  FetchTpsFailedOrder,
  RetryFailedOrder,
} from '../tps/tps';

const token = localStorage.getItem('token') || '';

class TPSRepository {
  FetchBasalamProducts = async (actions?: any) => {
    const makeRequest = new FetchBasalamProductsRequestBuilder().build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  getTpsFaildOrder = async (actions: any) => {
    const makeRequest = new FetchTpsFailedOrder().params({...actions.payload}).build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  getRegistrationTimes = async () => {
    const makeRequest = new FetchRegistrationTimes().build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  retryFaildOrder = async (actions: any) => {
    const makeRequest = new RetryFailedOrder().params(actions.payload).build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
}

export default new TPSRepository();
